import { useCallback, useEffect, useState } from 'react';
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import hero from '../assets/contents/hero.json';

const PAUSE_MS = 3000;
const TYPING_MS = 150;
const DELETE_FLOOR_MS = 62;

export const Background = () => {
    const [loopNum, setLoopNum] = useState(0);
    const [isDeleting, setIsDeleting] = useState(false);
    const [text, setText] = useState('');
    const [delta, setDelta] = useState(200);
    const [blinking, setBlinking] = useState(false);

    const tick = useCallback(() => {
        const fullText = hero.roles[loopNum % hero.roles.length];
        const updatedText = isDeleting
            ? (text.length === 1 ? '\u00A0' : fullText.substring(0, text.length - 1))
            : (text === '\u00A0' ? fullText.substring(0, 1) : fullText.substring(0, text.length + 1));
        setText(updatedText);

        if (isDeleting && delta === PAUSE_MS) {
            setDelta(500);
            setBlinking(false);
        } else if (isDeleting) {
            setDelta((prev) => (prev < 63 ? DELETE_FLOOR_MS : prev / 2));
        }

        if (!isDeleting && updatedText === fullText) {
            setIsDeleting(true);
            setBlinking(true);
            setDelta(PAUSE_MS);
        } else if (isDeleting && updatedText === '\u00A0') {
            setIsDeleting(false);
            setLoopNum((n) => n + 1);
            setDelta(TYPING_MS);
        }
    }, [loopNum, isDeleting, text, delta]);

    useEffect(() => {
        const ticker = setInterval(tick, delta);
        return () => clearInterval(ticker);
    }, [tick, delta]);

    return (
        <section className="welcome" id="home">
            <Container>
                <Row className="align-items-center pb-5">
                    <Col className="text-start">
                        <span className="hello">{hero.greeting}</span>
                        <h1 className="header">{hero.name}</h1>
                        <div className="wrap-container">
                            <p className="wrap">
                                {text}
                                <span className={`cursor ${blinking ? 'blinking' : ''}`}>|</span>
                            </p>
                        </div>
                        <div className="hireme-container">
                            <a
                                href="mailto:guybarel2006@gmail.com"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <button className="hireme">contact me</button>
                            </a>
                            <div className="hiremebg"></div>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col className="text-start">
                        <div className="scroll-indicator">
                            <span>scroll</span>
                            <div className="scroll-line"></div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};
